import React from 'react';
import { headerBlock as block } from '../../utils';
import HeaderDownloadAllButton from './HeaderDownloadAllButton';
import HeaderItem from './HeaderItem';
import HeaderSelectClipButton from './HeaderSelectClipButton';

const HeaderSelectClipActions: React.FC = () => {
  return (
    <HeaderItem>
      <div className={block('select-clip-actions-container')}>
        <HeaderDownloadAllButton />

        <HeaderSelectClipButton />
      </div>
    </HeaderItem>
  );
};

export default HeaderSelectClipActions;
